import { createContext, type ReactNode, useContext } from 'react';
import { NavIcon } from './Sidebar';

/** The assistant's own icon from Admin's branding (a PNG data URL), or null for the standard one. */
const AssistantIconContext = createContext<string | null>(null);

export function AssistantIconProvider({
  src,
  children,
}: {
  src: string | null;
  children: ReactNode;
}) {
  return <AssistantIconContext.Provider value={src}>{children}</AssistantIconContext.Provider>;
}

/** The assistant's icon in the menu and tab bar: Admin's picture, else the standard icon. */
export function AssistantIcon() {
  const src = useContext(AssistantIconContext);
  return src ? (
    <img src={src} alt="" aria-hidden="true" className="nv-assist-ic" />
  ) : (
    <NavIcon name="duet" />
  );
}
